<div class="avatar-container" *ngIf="userImageUrl; else initialsTemplate" [ngStyle]="avatarStyle">
  <img [src]="userImageUrl" alt="User Image" class="user-image">
</div>
<ng-template #initialsTemplate>
  <button class="user-initials" [ngStyle]="avatarStyle">{{ userInitials }}</button>
</ng-template>
